import { Box, SxProps, ThemeProvider, styled, useTheme } from '@mui/material'
import { ReactNode, useMemo } from 'react'

interface Props {
  children?: ReactNode
  className?: string
}

const LTRComponent = ({ children, className }: Props) => {
  const theme = useTheme()

  const ltrTheme = useMemo(() => {
    return { ...theme, direction: 'ltr' }
  }, [theme])

  return (
    <ThemeProvider theme={ltrTheme}>
      <div dir="ltr" className={className}>
        {children}
      </div>
    </ThemeProvider>
  )
}

export const LTR = styled(LTRComponent)``
